import { AuthorizeProvider } from '@b3networks/api/auth';
import { SSOLoginButton } from './login/login.component';

export const SSO_MAPPING: { [key in string]: SSOLoginButton } = {
  password: {
    authorizeProvider: AuthorizeProvider.password,
    url: 'assets/auth-shared/images/input_password_logo.png',
    text: 'Sign in with Password',
    activateText: 'Activate with Password',
    order: 0
  },
  microsoft: {
    authorizeProvider: AuthorizeProvider.microsoft,
    url: 'assets/auth-shared/images/ms_logo.png',
    text: 'Sign in with Microsoft',
    activateText: 'Activate with Microsoft',
    order: 2
  },
  google: {
    authorizeProvider: AuthorizeProvider.google,
    url: 'assets/auth-shared/images/google_logo.png',
    text: 'Sign in with Google',
    activateText: 'Activate with Google',
    order: 1
  },
  myinfo_singpass: {
    authorizeProvider: AuthorizeProvider.myinfo_singpass,
    url: '',
    text: '',
    order: 3
  }
};

export const SUPPORTED_SSO_LOGIN = ['password', 'microsoft', 'google', 'myinfo_singpass'];
